<template>
	<div>

	



		<mdb-row>
			<mdb-col md="12" style="margin-bottom: 30px;">
				<div class="form__group">
					<label for="recomendation_name" class="form__label" style="margin-bottom: 20px;">Recomendaciones registradas</label>
					<div class="recomendationsTable" v-for="(recomendation, index) in showRecommendations">
						<div class="item">{{index+1}}. {{recomendation.partnerName}} {{recomendation.partnerLastName}} {{recomendation.partnerMothersLastName}} | {{recomendation.email}}  | {{recomendation.cellPhone}} </div> 
					</div>
				</div>
			</mdb-col>
		</mdb-row>


	</div>
</template>
<script>
	import Btn from '../../core/Button';
	import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
	import { mapGetters, mapMutations } from "vuex";


	export default {
		name: "BeneficiaryRecomendationsData",
		components: {
			mdbContainer,
			mdbRow,
			mdbCol,
			Btn
		},
		data(){
			return {
				infoIdIcon: 'info-default.svg',
				 recommendationsA: this.recommendations,
			}

		},
		computed: {
			  ...mapGetters({
                recommendations: "getRecommendations",
            }),

  			showRecommendations(){
                return this.recommendations;
            },
		},
		methods: {
			chooseFile(){
				document.getElementById("fileUpload").click();
			},
			chooseFileCurp(){
				document.getElementById("fileUploadCurp").click();
			},
			chooseFileColonia(){
				document.getElementById("fileUploadColonia").click();
			},
			chooseFileCartaAntec(){
				document.getElementById("fileUploadCartaAntec").click();
			},
			chooseFileIdentificacion(){
				document.getElementById("fileUploadIdentificacion").click();
			},
			mouseOverIcon(){
				let infoIdIcon = this.infoIdIcon.split("-");
				this.infoIdIcon = `${infoIdIcon[0]}-hover.svg`;
			},
			mouseLeaveIcon(){
				let infoIdIcon = this.infoIdIcon.split("-");
				this.infoIdIcon = `${infoIdIcon[0]}-default.svg`;
			},
		}
	}
</script>
<style>
	.t1-input-colonia {
		/* max-width: 80%; */
		display: inline;
		transform: translateY(3px);
		margin-bottom: 10px !important; 
	}

	.t1-input-curp {
		display: inline; 
		max-width: 70%; 
		transform: translateY(3px);
	}

	.t1-input-dia,
	.t1-input-mes {
		text-align: center;
		display: inline; 
		width: 8%; 
		margin-right: 15px; 
		transform: translateY(3px);
	}

	.t1-input-ano {
		text-align: center; 
		display: inline; 
		width: 12%; 
		transform: translateY(3px);
	}

	.btn-comprobante-domicilio {
		/* margin-left: 10px; */
		display: inline;
	}

	.btn-acta-nacimiento {
		display: inline-block; 
		margin-left: 10px;
	}

	.btn-upload-curp {
		display: inline; 
		margin-left: 10px;
	}

	.info-icon {
		width: 2rem;
		height: 2rem;
		margin-left: 1rem;
		transition: transform .2s;
	}

	.info-icon:hover {
		transform: scale(1.3);
	}

	.recomendationsTable{
		width: 100%;
		height: auto;
		border: 1px solid #bdbdbd;
		border-radius: 8px;
		margin-bottom: 20px
	}

	.recomendationsTable .item{
		width: 100%;
		height: auto;
		border-bottom: 1px solid #bdbdbd;
		padding: 15px;
		display: block;
		color: #4f4f4f;
		font-size: 18px;
		font-weight: 400;
		text-align: left;
		cursor: pointer;
	}


	.recomendationsTable .item:last-child {
		border-bottom: 0px;
	}

	.custom-select{
		font-size: 1.8rem;
	    padding: .6rem 1rem;
        border-radius: .8rem;
        border: 0.15rem solid #bdbdbd;
        width: 100%;
        display: block;
        color: #828282;
        -webkit-transition: all .2s;
        transition: all .2s;
        height: 42px;
	}

	@media(max-width: 1199px){
		.t1-input-curp {
			display: block; 
			max-width: 100%; 
			transform: translateY(3px);
		}

		.t1-input-dia,
		.t1-input-mes {
			width: 12%; 
		}


		.t1-input-ano {
			width: 18%; 
		}

		.btn-upload-curp {
			display: block; 
			margin-top: 10px;
			margin-left: 0px;
		}

		.btn-acta-nacimiento {
			display: block; 
			margin-left: 0px;
			margin-top: 10px;
		}
	}

	@media(max-width: 992px){
		.btn-comprobante-domicilio {
			margin-left: 0px;
			display: block;
		}

		.t1-input-dia,
		.t1-input-mes {
			width: 18%; 
		}


		.t1-input-ano {
			width: 28%; 
		}


		.t1-input-colonia {
			max-width: 100%;
			margin-bottom: 10px;
			display: block;
		} 
	}

	@media(max-width: 768px){
		.t1-input-colonia {
			max-width: 100%;
		}
	}

	@media (max-width: 576px) { 

		}
</style>
